import React, { useEffect } from 'react';
import AgentService from '../../../Services/agent/agent.service';
import messages from '../../../Services/agent/messages';
import AuthService from '../../../Services/auth.service';

interface AgentInitializerProps {
  isUserLoggedIn: boolean;
}

const AgentInitializer: React.FC<AgentInitializerProps> = ({ isUserLoggedIn }) => {
  useEffect(() => {
    if (isUserLoggedIn) {
      const currentUser = AuthService.getInstance().getCurrentUser();
      const agentService = AgentService.getInstance();
      
      agentService.setCurrentMessage(
        messages.USER_WELCOME_MESSAGE,
        {
          name: currentUser?.firstName
            ? currentUser.firstName.charAt(0).toUpperCase() +
              currentUser.firstName.slice(1)
            : "",
        },
        ""
      );
      
      const onCheckClicked = (action: string) => {
        alert(`${action} clicked`);
      };

      agentService.subscribe(
        AgentService.EVENTS.ACTION_BUTTON_CLICKED,
        onCheckClicked
      );

      return () => {
        agentService.unsubscribe(
          AgentService.EVENTS.ACTION_BUTTON_CLICKED,
          onCheckClicked
        );
      };
    } else {
      AgentService.getInstance().setCurrentMessage(
        messages.USER_WELCOME_MESSAGE,
        { name: "there" },
        ""
      );
    }
  }, [isUserLoggedIn]);

  return null;
};

export default AgentInitializer; 